// extracted by mini-css-extract-plugin
module.exports = {"TEIDLogo":"TEIDLogo_TEIDLogo__2vgcW","Link":"TEIDLogo_Link__sezTA"};